import React, { useState } from 'react';
import DatePicker from 'react-datepicker'; // npm install react-datepicker@7.1.0 --legacy-peer-deps
import 'react-datepicker/dist/react-datepicker.css';
import { format, parse } from 'date-fns';
import "./DynamicDatePicker.css";
import localeMap from "../crud/locales";
import useApp from '../AppContext';
import { t } from '../i18n';
function DynamicDatePicker({
    value, pickerType, dateFormat, onChange, caption, readOnly, disabled
}) {
    const app = useApp()
    const [language] = useState((app.sessionToken?.Language));
    const [isFocused, setIsFocused] = useState(false);

    const formatdate = (dateFormat) ? dateFormat : (pickerType === 'DateTime') ? "dd/MM/yyyy HH:mm" : (pickerType === 'Time') ? "HH:mm" : "dd/MM/yyyy";

    const getTimeCaption = () => {
        return t('bookingFrequency.time', language);
    };

    const handleDateChange = (date) => {
        if (pickerType === 'DateTime' && (date instanceof Date && !isNaN(date))) {
            const formattedDate = format(date, "yyyy-MM-dd'T'HH:mm");
            onChange(formattedDate);
        }
        else if (pickerType === 'Time' && (date instanceof Date && !isNaN(date))) {
            onChange(format(date, "HH:mm").toString());
        }
        else if (date instanceof Date && !isNaN(date)) {
            onChange(format(date, "yyyy-MM-dd'T'00:00"));
        }
        else {
            onChange(null);
        }
    };

    return (
        <div className="d-flex justify-content-start align-items-center position-relative">
            {caption && (
                <label
                    className={`form-label-custom-datePicker ${(value || isFocused) ? 'active' : ''}`}
                >
                    {caption}
                </label>
            )}

            <DatePicker
                label={caption}
                selected={(!value) ? null : parse(value, formatdate, new Date())}
                onChange={handleDateChange}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                showTimeSelect={(pickerType === 'DateTime' || pickerType === 'Time') ? true : false}
                showTimeSelectOnly={(pickerType === 'Time') ? true : false}
                timeFormat="HH:mm:ss"
                timeCaption={getTimeCaption()}
                timeIntervals={15}
                dateFormat={formatdate}
                locale={localeMap[language] || localeMap['el']}
                disabled={disabled}
                readOnly={readOnly}
                className="form-control"
            />
        </div>
    );
}

export default DynamicDatePicker;
